// extracted by mini-css-extract-plugin
module.exports = {"factBox":"fact-box-module--fact-box--1DIMM"};